module.exports = __webpack_public_path__ + "img/icon_lvjing_fugu_normal@2x.afc0e17c.png";